import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import { HelicopterIcon } from '@rsos/assets/icons';
import { removeAirAmbulanceRequest } from '@rsos/reduxDataStore';
import { displayMilitaryTime } from '@rsos/utils/timeHelpers';
import {
  Container,
  IconBox,
  AirAmbulanceQueueBox,
  AirAmbulanceTitle,
  TimeBox,
  Time,
  SecondarDetails,
  RemoveAirAmbulance,
} from './AirAmbulance.styles';

const expiredCallAge = 6 * 60 * 60 * 1000; // 6 hours

const AirAmbulance = ({
  airAmbulanceID,
  startTime,
  isSearchResult,
  isSearchResultHovered,
  isSelected,
  rightClickedAirAmbulanceID,
  setIsRemoveAirAmbulanceVisible,
  status,
}) => {
  const dispatch = useDispatch();

  const [displayRemoveAirAmbulance, setDisplayRemoveAirAmbulance] = useState(
    rightClickedAirAmbulanceID,
  );
  const animateProps = useSpring({
    config: { duration: 200 },
    display: displayRemoveAirAmbulance ? 'flex' : 'none',
    opacity: displayRemoveAirAmbulance ? 1 : 0,
  });

  useEffect(() => {
    airAmbulanceID === rightClickedAirAmbulanceID
      ? setDisplayRemoveAirAmbulance(true)
      : setDisplayRemoveAirAmbulance(false);
  }, [airAmbulanceID, rightClickedAirAmbulanceID]);

  const handleRemoveAirAmbulance = useCallback(
    e => {
      e.stopPropagation();
      dispatch(removeAirAmbulanceRequest(airAmbulanceID));
      setDisplayRemoveAirAmbulance(false);
      setIsRemoveAirAmbulanceVisible(false);
    },
    [dispatch, airAmbulanceID, setIsRemoveAirAmbulanceVisible],
  );

  useEffect(() => {
    if (!startTime) return;

    const currentTime = new Date().getTime();

    const remainingTime = currentTime + expiredCallAge - startTime; // Ensure non-negative timeout
    const timer = setTimeout(() => {
      dispatch(removeAirAmbulanceRequest(airAmbulanceID));
    }, remainingTime);

    return () => clearTimeout(timer); // Cleanup if startTime changes
  }, [dispatch, startTime, handleRemoveAirAmbulance, airAmbulanceID]);
  const mostRecentStatus = useMemo(() => {
    const statusSize = status.length;
    return status[statusSize - 1];
  }, [status]);
  return (
    <Container
      isExpired={false} // TODO: based on future status
      isHovered={isSearchResultHovered}
      isSearchResult={isSearchResult}
      isSelected={isSelected}
      onClick={() => {}}
    >
      <IconBox>{<HelicopterIcon width={24} />}</IconBox>
      <AirAmbulanceQueueBox>
        <AirAmbulanceTitle>Air Ambulance</AirAmbulanceTitle>
        <SecondarDetails>{mostRecentStatus.update}</SecondarDetails>
      </AirAmbulanceQueueBox>
      {startTime && (
        <TimeBox>
          <Time>
            {displayMilitaryTime(new Date(mostRecentStatus.timestamp))}
          </Time>
        </TimeBox>
      )}
      <animated.div style={animateProps}>
        <RemoveAirAmbulance onClick={handleRemoveAirAmbulance}>
          Remove
        </RemoveAirAmbulance>
      </animated.div>
    </Container>
  );
};

export default AirAmbulance;
